import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AjaxErrorAlert, usePromise } from '@cancercentrum/rcc-react';
import { Button } from '@cancercentrum/rcc-bootstrap';
import { faPlusCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { addParticipantToUtskicksprojekt } from '../enkatregistret.ts';
import type { Utskicksprojekt } from '../types.ts';
import { useIPO } from '../../../hooks/useIPO.ts';

export const NotInProject = (props: {
    utskicksprojekt: Utskicksprojekt;
    reload: () => void;
    sparrad: boolean;
}) => {
    const { utskicksprojekt, reload, sparrad } = props;
    const { isLoading, error, exec } = usePromise();
    const ipo = useIPO();

    const onClick = () => {
        exec(addParticipantToUtskicksprojekt(utskicksprojekt.config.id, ipo.patient).then(() => {
            reload();
        }));
    };

    if (!utskicksprojekt.handledByIpo) {
        return <em>Hanteras centralt</em>;
    }

    if (sparrad) {
        return <em>Deltagande spärrat</em>;
    }

    return (
        <div>
            <Button bsStyle="primary" bsSize="sm" disabled={isLoading} onClick={onClick}>
                <FontAwesomeIcon icon={isLoading ? faSpinner : faPlusCircle} spin={isLoading} fixedWidth={true} /> Skapa personlig kod
            </Button>
            {!!error && <AjaxErrorAlert error={error} className="mt-3 mb-0" />}
        </div>
    );
};
